import ModalContextProviderExample from "../../../../../../packages/design-system/entry-points/examples/constellation/modal-context-provider";
import RAW_UNSAFEUPUPSLASHUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmodal_context_provider from "!!raw-loader!../../../../../../packages/design-system/entry-points/examples/constellation/modal-context-provider";
import * as React from 'react';
export default {
  ModalContextProviderExample,
  RAW_UNSAFEUPUPSLASHUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmodal_context_provider,
  React
};